import React from 'react';
import { connect } from 'react-redux';
import { AudioElementVolume } from '../menus/AudioElementVolume';
import { AudioTrackMenu } from '../menus/AudioTrackMenu';
import audioEditorUtils from '../utils/AudioEditorUtils';
import properties from '../../../constants/Properties';
import { SlideDurationSlider } from '../../../components/menus/SlideDurationSlider';
import mouseUtils from '../../utils/MouseUtils';
import { changeZoom } from '../../../actions/AudioEditorActions';
import storeManager from '../../../store/StoreManager';
import playController from '../../utils/PlayController';
import hoverManager from '../../utils/HoverManager';
import audioToolUtils from '../../audioTool/utils/AudioToolUtils';
import saveManager from '../../utils/SaveManager';
import locales from "../../../locales/LocalesManager";

const ZoomComponent = React.createClass({
    getInitialState() {
        return {
            isMinusOver: false,
            isPlusOver: false
        }
    },
    onMinusMouseIn () {
        hoverManager.show(this.refs.minus, 'zoomMinus', 'right');

        this.setState({
            isMinusOver: true
        });
    },
    onMinusMouseOut () {
        hoverManager.hide();

        this.setState({
            isMinusOver: false
        });
    },
    onPlusMouseIn () {
        hoverManager.show(this.refs.plus, 'zoomPlus');

        this.setState({
            isPlusOver: true
        });
    },
    onPlusMouseOut () {
        hoverManager.hide();

        this.setState({
            isPlusOver: false
        });
    },
    onMinusClick (e) {
        if (playController.isPlaying)
            return;

        if (mouseUtils.rejectMouseEvent(e))
            return;

        var zoom = this.getCurrrentZoomIndex();
        var oldZoom = audioEditorUtils.getZoomValue();

        zoom = zoom - 1;

        if (zoom < 0)
            zoom = 0;

        this.props.dispatch(changeZoom(zoom));
        audioEditorUtils.addActionToHistory();
        audioEditorUtils.checkTimelineWidth(true, oldZoom, true);
        saveManager.isContentChanged(true);
    },
    onPlusClick (e) {
        if (playController.isPlaying)
            return;

        if (mouseUtils.rejectMouseEvent(e))
            return;

        var zoom = this.getCurrrentZoomIndex();
        var oldZoom = audioEditorUtils.getZoomValue();

        zoom = zoom + 1;

        if (zoom > audioEditorUtils.maxZoom)
            zoom  = audioEditorUtils.maxZoom;

        this.props.dispatch(changeZoom(zoom));
        audioEditorUtils.addActionToHistory();
        audioEditorUtils.checkTimelineWidth(true, oldZoom, true);
        saveManager.isContentChanged(true);
    },
    getCurrrentZoomIndex() {
        const state = storeManager.getState();
        var zoom = state.audioEditor.zoomValue;

        if (zoom == undefined) {
            if (audioToolUtils.isAudioTool())
                return 1;
            else
                return 4;
        } else
            return zoom;
    },
    getText() {
        var zoomValue = audioEditorUtils.getZoomValue();

        return '' + zoomValue * 100 + '%';
    },
    render() {
        var sliderProperties = {};
        sliderProperties.topPosition = 0;
        sliderProperties.leftPosition = 33;
        sliderProperties.width = properties.RECORGING_SLIDER_WIDTH + 30;
        sliderProperties.height = properties.RECORDING_BUTTON_HEIGHT;
        sliderProperties.thumbSize = 20;
        sliderProperties.start = 0;
        sliderProperties.end = audioEditorUtils.maxZoom;
        sliderProperties.step = 1;
        sliderProperties.dispatch = this.props.dispatch;
        sliderProperties.isZoom = true;
        sliderProperties.currentValue = this.getCurrrentZoomIndex();

        var zoomHolderStyle = {
            position: 'absolute',
            top: audioToolUtils.timelineHeight() * audioEditorUtils.getTimelinesLength() + properties.LINE_SIZE,
            left: 0,
            width: audioToolUtils.buttonsHolderWidth(),
            height: 30,
            background: properties.RECORDING_MENU_BACKGROUND
        };

        if (audioToolUtils.isAudioTool()) {
            zoomHolderStyle.top = undefined;
            zoomHolderStyle.bottom = 0;
            zoomHolderStyle.position = 'fixed';
        }

        var color = '#272727';

        if (this.state.isMinusOver)
            color = properties.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;

        const zoomMinusButton = {
            position: 'absolute',
            left: 7,
            width: 24,
            height: 24,
            margin: 0,
            padding: 0,
            boxSizing: 'initial',
            fontSize: 'initial',
            background: 'none',
            borderStyle: 'none'
        };

        const zoomMinus = {
            position: 'absolute',
            top: 6,
            left: 6,
            color: color
        };

        if (this.state.isPlusOver)
            color = properties.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
        else
            color = '#272727';

        const zoomPlusButton = {
            position: 'absolute',
            right: 7,
            width: 24,
            height: 24,
            margin: 0,
            padding: 0,
            boxSizing: 'initial',
            fontSize: 'initial',
            background: 'none',
            borderStyle: 'none'
        };

        const zoomPlus = {
            position: 'absolute',
            top: 6,
            right: 6,
            color: color
        };

        return (
            <div style={zoomHolderStyle}>
                <button ref='minus' style={zoomMinusButton} aria-label={locales.getCaption('zoomMinus', 'hover')} onMouseOver={this.onMinusMouseIn} onMouseOut={this.onMinusMouseOut} onTouchEnd={this.onMinusClick} onClick={this.onMinusClick}>
                    <i style={zoomMinus} className="fa fa-minus fa-1x"/>
                </button>

                <SlideDurationSlider properties={sliderProperties}/>

                <button ref='plus' style={zoomPlusButton} aria-label={locales.getCaption('zoomPlus', 'hover')} onMouseOver={this.onPlusMouseIn} onMouseOut={this.onPlusMouseOut} onTouchEnd={this.onPlusClick} onClick={this.onPlusClick}>
                    <i style={zoomPlus} className="fa fa-plus fa-1x"/>
                </button>
            </div>
        );
    }
});

const AudioEditorControlsContent = React.createClass({
    render() {
        if (!this.props.timelines)
            return (<div/>);

        var height = audioEditorUtils.getAudioEditorHeight();
        const listHeight = audioToolUtils.isAudioTool() ? properties.SLIDE_VIEWER_TOP_GAP * 5 : properties.SLIDE_VIEWER_LIST_HEIGHT + properties.SLIDE_VIEWER_TOP_GAP;
        const normalSlideViewerHeight = properties.SLIDE_VIEWER_TOP_LINE_HEIGHT + listHeight + properties.SLIDE_VIEWER_BOTTOM_GAP;

        var menuStyle = {
            position: 'absolute',
            cursor: 'default',
            userSelect: 'none',
            WebkitUserSelect: 'none',
            top: normalSlideViewerHeight + properties.SLIDE_VIEWER_TOP_GAP,
            left: 0,
            width: audioToolUtils.buttonsHolderWidth(),
            height
        };

        var timelines = [];
        var i;
        var maxTimelines = audioEditorUtils.getMaxTimelinesRelatedToHeight();

        for (i=0; i<this.props.timelines.length; i++) {
            if (i < maxTimelines)
                timelines.push(<AudioElementVolume key={'track_' + i} index={i} dispatch={this.props.dispatch} timeline={this.props.timelines[i]} menuIndex={this.props.index}/>);
        }

        var zoomComponent = <ZoomComponent dispatch={this.props.dispatch} zoomValue={this.props.zoomValue} topOffset={menuStyle.top} windowHeight={this.props.windowHeight}/>;

        if (audioToolUtils.buttonsHolderWidth() == properties.BUTTONS_HOLDER_COLLAPSED_WIDTH)
            zoomComponent = undefined;

        return (
            <div style={menuStyle}>
                {timelines}
                <AudioTrackMenu dispatch={this.props.dispatch}/>
                {zoomComponent}
            </div>
        );
    }
});

function mapStateToProps(state) {
    const timelines = state.audioEditor.timelines;
    var zoomValue = state.audioEditor.zoomValue;
    var index = state.audioEditor.trackMenu;

    if (index == undefined)
        index = -1;

    if (zoomValue == undefined)
        zoomValue = 4;

    return {
        timelines,
        zoomValue,
        index
    };
}

export const AudioEditorControls = connect(mapStateToProps)(AudioEditorControlsContent);



/** WEBPACK FOOTER **
 ** ./src/components/audioEditor/menus/AudioEditorControls.js
 **/